import { setError } from 'actions/error';
import {
  AuthLoginAPIRequest,
  CreateRegistrationFatsomaAPIRequest,
  CreateUserAPIRequest,
  DeleteACLUserAPIRequest,
  FetchACLUsersAPIRequest,
  FetchPasswordResetAPIRequest,
  FetchUserRoleAPIRequest,
  QueryAuthorizedVenuesAPIRequest,
  RequestPasswordResetAPIRequest,
  UpdateACLUserAPIRequest,
  VerifyPasswordResetAPIRequest,
} from 'utils/constants/network';
import { callJSONAPI } from 'utils/jsonapi/network';
import { callAPI } from 'utils/network';

export const REQUEST_LOGIN_SUBMISSION = 'REQUEST_LOGIN_SUBMISSION';
export const RECEIVE_LOGIN_SUBMISSION = 'RECEIVE_LOGIN_SUBMISSION';
export const RECEIVE_REGISTER_SUBMISSION = 'RECEIVE_REGISTER_SUBMISSION';
export const REQUEST_REGISTER_SUBMISSION = 'REQUEST_REGISTER_SUBMISSION';
export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const RECEIVE_PASSWORD_RESET = 'RECEIVE_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_CONFIRM = 'REQUEST_PASSWORD_RESET_CONFIRM';
export const RECEIVE_PASSWORD_RESET_CONFIRM = 'RECEIVE_PASSWORD_RESET_CONFIRM';
export const REQUEST_PASSWORD_RESET_DETAILS = 'REQUEST_PASSWORD_RESET_DETAILS';
export const RECEIVE_PASSWORD_RESET_DETAILS = 'RECEIVE_PASSWORD_RESET_DETAILS';
export const CREATING_USER = 'CREATING_USER';
export const USER_CREATED = 'USER_CREATED';
export const REQUEST_USER_ROLE = 'REQUEST_USER_ROLE';
export const RECEIVE_USER_ROLE = 'RECEIVE_USER_ROLE';
export const CLEAR_AUTH_FLAGS = 'CLEAR_AUTH_FLAGS';
export const SET_HAS_VENUES = 'SET_HAS_VENUES';
// User Management
export const REQUEST_CREATE_USER = 'REQUEST_CREATE_USER';
export const SET_ACL_USERS = 'SET_ACL_USERS';
export const UPDATE_ACL_USER = 'UPDATE_ACL_USER';
export const DELETE_ACL_USER = 'DELETE_ACL_USER';

export const clearAuthFlags = () => {
  return {
    type: CLEAR_AUTH_FLAGS,
    payload: {
      loginError: {},
      registerError: {},
    },
  };
};

export const setHasVenues = hasVenues => {
  return {
    type: SET_HAS_VENUES,
    payload: {
      hasVenues,
    },
  };
};

const requestLoginSubmission = () => ({
  type: REQUEST_LOGIN_SUBMISSION,
  payload: {
    loading: true,
  },
});

export const receiveLoginSubmission = (token, hasVenues) => {
  var error = {};

  if (!token) {
    error.detail = 'Invalid email or password';
  }

  let payload = {
    loading: false,
    accessToken: token,
    loginError: error,
  };

  if (hasVenues != null) {
    payload['hasVenues'] = hasVenues;
  }

  return {
    type: RECEIVE_LOGIN_SUBMISSION,
    payload,
  };
};

const requestRegisterSubmission = () => ({
  type: REQUEST_REGISTER_SUBMISSION,
  payload: {
    loading: true,
  },
});

export const receiveRegisterSubmission = (
  token,
  userCreated,
  validationErrors
) => {
  var error = {};

  if (!token) {
    if (userCreated) {
      error.detail =
        'User created but unable to sign in. Please attempt to sign in.';
    } else {
      error.detail = 'Could not register. Please try again.';
    }

    error.validationErrors = validationErrors;
  }

  return {
    type: RECEIVE_REGISTER_SUBMISSION,
    payload: {
      loading: false,
      accessToken: token,
      registerError: error,
    },
  };
};

const requestUserRole = () => ({
  type: REQUEST_USER_ROLE,
  payload: {
    fetchingUserRole: true,
  },
});

const receiveUserRole = (success, role, user, permissions) => ({
  type: RECEIVE_USER_ROLE,
  payload: {
    fetchingUserRole: false,
    role,
    user,
    permissions,
  },
});

const requestPasswordReset = () => ({
  type: REQUEST_PASSWORD_RESET,
  payload: {
    loading: true,
  },
});

const receivePasswordReset = error => ({
  type: RECEIVE_PASSWORD_RESET,
  payload: {
    loading: false,
    resetError: error,
    resetLinkSent: error.detail === undefined,
  },
});

const requestPasswordResetConfirmation = () => ({
  type: REQUEST_PASSWORD_RESET_CONFIRM,
  payload: {
    loading: true,
  },
});

const receivePasswordResetConfirmation = error => ({
  type: RECEIVE_PASSWORD_RESET_CONFIRM,
  payload: {
    loading: false,
    resetConfirmationError: error,
    didResetPassword: error.detail === undefined,
  },
});

const requestPasswordResetDetails = () => ({
  type: REQUEST_PASSWORD_RESET_DETAILS,
  payload: {
    loading: true,
  },
});

const receivePasswordResetDetails = (email, error) => ({
  type: RECEIVE_PASSWORD_RESET_DETAILS,
  payload: {
    loading: false,
    resetEmailAddress: email,
    resetConfirmationError: error,
  },
});

// const creatingUser = () => ({
//   type: CREATING_USER,
//   payload: {
//     creatingUser: true,
//   },
// });

// const userCreated = success => ({
//   type: USER_CREATED,
//   payload: {
//     creatingUser: false,
//     userCreated: success,
//   },
// });

// User Management
const requestCreateUser = () => ({
  type: REQUEST_CREATE_USER,
  payload: {
    createUser: true,
    userCreated: false,
    creaingUserError: null,
  },
});

const requestDeleteACLUser = deleted => ({
  type: DELETE_ACL_USER,
  payload: {
    deletingACLUser: false,
    ACLUserDeleted: deleted,
  },
});

const requestUpdatedACLUser = updated => ({
  type: UPDATE_ACL_USER,
  payload: {
    updatingACLUser: false,
    ACLUserUpdated: updated,
  },
});

const setACLUsers = users => ({
  type: SET_ACL_USERS,
  payload: {
    ACLUsers: users,
    fetchingACLUsers: false,
  },
});

export const submitLoginRequest = (email, pwd) => {
  return dispatch => {
    dispatch(requestLoginSubmission(email, pwd));

    const apiRequest = AuthLoginAPIRequest({ email: email, password: pwd });

    return callAPI(apiRequest)
      .then(async json => {
        const manageableVenuesApiRequest = QueryAuthorizedVenuesAPIRequest({
          query: '',
        });
        let hasVenues = false;

        if (json.token) {
          try {
            const response = await callAPI(
              manageableVenuesApiRequest,
              false,
              false,
              0,
              json.token
            );
            hasVenues = response.venues.length > 0;
          } catch (e) {
            hasVenues = false;
          }
        }

        dispatch(receiveLoginSubmission(json.token, hasVenues));
      })
      .catch(err => dispatch(receiveLoginSubmission(null, false)));
  };
};

export const submitRegisterRequest = (firstName, lastName, email, password) => {
  return async dispatch => {
    dispatch(requestRegisterSubmission());

    try {
      const registrationRequest = CreateRegistrationFatsomaAPIRequest({
        firstName,
        lastName,
        email,
        password,
      });
      await callJSONAPI(registrationRequest);
    } catch (e) {
      dispatch(receiveRegisterSubmission(null, false, e.validationErrors));
      return;
    }

    try {
      const loginRequest = AuthLoginAPIRequest({ email, password });
      const json = await callAPI(loginRequest);

      const base64Url = json.token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const decodedToken = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );

      const parsedToken = JSON.parse(decodedToken);

      if (parsedToken.User.is_invited_user) {
        const manageableVenuesApiRequest = QueryAuthorizedVenuesAPIRequest({
          query: '',
        });
        let hasVenues = false;

        if (json.token) {
          try {
            const response = await callAPI(
              manageableVenuesApiRequest,
              false,
              false,
              0,
              json.token
            );
            hasVenues = response.venues.length > 0;
          } catch (e) {
            hasVenues = false;
          }
        }

        dispatch(receiveLoginSubmission(json.token, hasVenues));
      }

      dispatch(receiveRegisterSubmission(json.token, true));
    } catch (e) {
      dispatch(receiveRegisterSubmission(null, true));
    }
  };
};

export const submitPasswordRequest = email => {
  return dispatch => {
    dispatch(receivePasswordReset({ message: 'pending' }));
    dispatch(requestPasswordReset());

    const rpcRequest = RequestPasswordResetAPIRequest({ email: email });

    return callAPI(rpcRequest)
      .then(json => dispatch(receivePasswordReset({})))
      .catch(err => dispatch(receivePasswordReset(err)));
  };
};

// export const createUser = user => {
//   return dispatch => {
//     dispatch(creatingUser());

//     const apiRequest = CreateUserAPIRequest({
//       user: user,
//       assignToVenue: true,
//     });

//     return callAPI(apiRequest)
//       .then(json => dispatch(userCreated(true)))
//       .catch(err => dispatch(userCreated(false)));
//   };
// };

export const fetchUserRole = () => {
  return dispatch => {
    dispatch(requestUserRole());

    const apiRequest = FetchUserRoleAPIRequest({});

    return callAPI(apiRequest)
      .then(json => {
        window.Intercom('boot', {
          app_id: process.env.REACT_APP_INTERCOM_APP_ID,
          email: json.user.email,
          user_id: json.user.id,
        });

        return dispatch(
          receiveUserRole(true, json.role, json.user, json.permissions)
        );
      })
      .catch(e => dispatch(receiveUserRole(false, null, null, [])));
  };
};

export const fetchPasswordResetDetails = resetID => {
  return dispatch => {
    receivePasswordResetDetails('', { message: 'pending' });
    dispatch(requestPasswordResetDetails());

    const rpcRequest = FetchPasswordResetAPIRequest({ id: resetID });

    return callAPI(rpcRequest)
      .then(json =>
        dispatch(receivePasswordResetDetails(json.passwordReset.email, {}))
      )
      .catch(err => dispatch(receivePasswordResetDetails('', err)));
  };
};

export const submitPasswordResetConfirmation = (
  email,
  newPassword,
  resetID
) => {
  return dispatch => {
    dispatch(requestPasswordResetConfirmation());

    const rpcRequest = VerifyPasswordResetAPIRequest({
      email: email,
      newPassword: newPassword,
      id: resetID,
    });

    return callAPI(rpcRequest)
      .then(json => dispatch(receivePasswordResetConfirmation({})))
      .catch(err => dispatch(receivePasswordResetConfirmation(err)));
  };
};

// User Management
export const createUser = payload => {
  return dispatch => {
    dispatch(requestCreateUser());

    const apiRequest = CreateUserAPIRequest(payload);

    return callAPI(apiRequest, false, true)
      .then(() => {
        dispatch(requestCreateUser(true, null));
      })
      .catch(err => {
        dispatch(requestCreateUser(false, err.message));
      });
  };
};

export const deleteACLUser = user_id => {
  return dispatch => {
    dispatch(requestDeleteACLUser());

    const apiRequest = DeleteACLUserAPIRequest({ user_id });

    return callAPI(apiRequest)
      .then(() => dispatch(requestDeleteACLUser(true)))
      .catch(err => {
        dispatch(setError(err));
        dispatch(requestDeleteACLUser(false));
      });
  };
};

export const UpdateACLUser = payload => {
  return dispatch => {
    const apiRequest = UpdateACLUserAPIRequest(payload);

    return callAPI(apiRequest)
      .then(() => dispatch(requestUpdatedACLUser(true)))
      .catch(err => {
        dispatch(setError(err));
        dispatch(requestUpdatedACLUser(false));
      });
  };
};

export const fetchACLUsers = () => {
  return dispatch => {
    const apiRequest = FetchACLUsersAPIRequest();
    return callAPI(apiRequest)
      .then(json => {
        dispatch(setACLUsers(json));
      })
      .catch(err => {
        dispatch(setError(err));
        dispatch(setACLUsers(null));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authentication/index.js